import { render, staticRenderFns } from "./WebphoneIcon.vue?vue&type=template&id=66a2227e"
import script from "./WebphoneIcon.vue?vue&type=script&lang=js"
export * from "./WebphoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports